export default "__VITE_ASSET__BxR0fFkn__"